export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M20.204 4.01A2 2 0 0 1 22 6v13a2 2 0 0 1-1.796 1.99L20 21H4a2 2 0 0 1-1.99-1.796L2 19V6a2 2 0 0 1 2-2h16l.204.01ZM3.5 19a.5.5 0 0 0 .5.5h1V16h6v3.5h2V16h6v3.5h1a.5.5 0 0 0 .5-.5v-9h-17v9Zm7.5-4H5v-4h6v4Zm8 0h-6v-4h6v4ZM4 5.5a.5.5 0 0 0-.5.5v2.5h17V6a.5.5 0 0 0-.5-.5H4Z"/>
</svg>
`;
